var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { cx } from '@web/utility';
import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
export function TooltipRow(_a) {
    var data = _a.data, label = _a.label, className = _a.className;
    return (_jsxs("p", __assign({ className: cx('items-center flex flex-row gap-2', className) }, { children: [_jsxs("span", __assign({ className: "font-normal text-gray-600" }, { children: [label, ":"] })), _jsx("span", __assign({ className: "font-bold text-gray-900" }, { children: data }))] })));
}
export function Tooltip(_a) {
    var children = _a.children, id = _a.id, content = _a.content, _b = _a.place, place = _b === void 0 ? 'top' : _b, className = _a.className, tooltipContainerClassName = _a.tooltipContainerClassName, _c = _a.enabled, enabled = _c === void 0 ? true : _c, style = _a.style;
    var tooltipId = id || Math.random().toString(36).substring(7);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ "data-tooltip-id": tooltipId, className: tooltipContainerClassName }, { children: children })), enabled && (_jsx(ReactTooltip, __assign({ id: tooltipId, place: place, className: cx('max-w-96 text-wrap break-words', className), style: __assign({ zIndex: 99 }, style) }, { children: content })))] }));
}
